// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InputInternalWrapper-inputWrapperRoot__biPPT{display:flex;flex:1 0 0;flex-direction:column;gap:var(--size-1);width:var(--size-full)}.InputInternalWrapper-labelWrap__Tuqdb{display:flex;align-items:center;justify-content:space-between}.InputInternalWrapper-horizontalHelpText__sXgGq{display:flex;flex-wrap:wrap;gap:var(--size-4);align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapperRoot": "InputInternalWrapper-inputWrapperRoot__biPPT",
	"labelWrap": "InputInternalWrapper-labelWrap__Tuqdb",
	"horizontalHelpText": "InputInternalWrapper-horizontalHelpText__sXgGq"
};
export default ___CSS_LOADER_EXPORT___;
